import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { AamBackendApi } from 'src/libs/aamBackendApi';

import { Notification, NotificationBody } from '@adeccoux/tag-ds';
import { PageWrapper } from '@components/app/PageWrapper/PageWrapper';
import { useInjection } from '@context/inversify-context-provider';
import { Utils } from '@helpers/utils';
import { TYPES } from '@libs/InversifyType';
import { ServiceBusMessage } from '@models/serviceBusMessage';
import CircularProgress from '@mui/material/CircularProgress';

import { IntegrationMessageHistoryTable } from './components/IntegrationMessageHistoryTable';

export const IntegrationMessageHistoryPage: FC = () => {
  const { t } = useTranslation(['recruiter']);
  const aamBackendApi = useInjection<AamBackendApi>(TYPES.AamBackendApi);
  const [isFetching, setIsFetching] = useState<boolean>(true);
  const params = useParams<{ userId?: string }>();
  const [userId] = useState<string | undefined>(params?.userId);
  const [messages, setMessages] = useState<ServiceBusMessage[]>([]);
  const [error, setError] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!userId || !Utils.uuidValidator(userId)) {
      setError('Invalid parameter provided');
      return;
    }

    setIsFetching(true);
    aamBackendApi
      .fetchAllServiceBusMessagesByUserId(userId)
      .then((mess) => {
        setMessages(mess);
      })
      .catch((err) => setError(err?.message ? err.message : JSON.stringify(err)))
      .finally(() => setIsFetching(false));
  }, [userId, aamBackendApi]);

  return (
    <div className="admin">
      <PageWrapper
        pageName="feature-integration-messages-history"
        featureName="feature-integration-messages-history"
        sideMenu={true}
        headerConfig={{ pageName: t('recruiter:GENERAL.INTEGRATIONMESSAGEHISTORY.title'), languagePicker: true }}
      >
        <div className="tag-ds">
          <div className="feature-integration-messages-history">
            {error ? (
              <Notification icon={<span className="material-icons">error_outline</span>} error show={true}>
                <NotificationBody>{error}</NotificationBody>
              </Notification>
            ) : (
              isFetching && (
                <div className="loader">
                  <CircularProgress />
                </div>
              )
            )}
            {messages.length > 0 && <IntegrationMessageHistoryTable userId={userId} messages={messages} />}
          </div>
        </div>
      </PageWrapper>
    </div>
  );
};
